
import Vue from "vue";
import Component from "vue-class-component";

import StringField from "@/shared/fields/StringField.vue";
import PaysField from "@/shared/fields/PaysField.vue";
import DateField from "@/shared/fields/DateField.vue";
import RequiredSexe from "@/shared/fields/RequiredSexe.vue";
import ListeStrings from "@/shared/fields/ListeStrings.vue";
import { formatTel, nullResponsableInscription } from "@/shared/logic/utils";
import { ResponsableLegal } from "@/shared/logic/types";
import { scrollToError } from "@/shared/utils";

const TabRespoProps = Vue.extend({
  props: {
    respoOuter: Object as () => ResponsableLegal
  },
  model: {
    prop: "respoOuter",
    event: "change"
  }
});

@Component({
  components: { StringField, DateField, RequiredSexe, ListeStrings, PaysField }
})
export default class TabRespo extends TabRespoProps {
  validated = false;

  formatTel = formatTel;

  $refs!: {
    form: HTMLFormElement;
  };

  get respo(): ResponsableLegal {
    return this.respoOuter == null
      ? nullResponsableInscription()
      : this.respoOuter;
  }

  get disabled() {
    return this.respoOuter == null;
  }

  valid() {
    this.validated = true;
    this.$nextTick(() => {
      const isValid = scrollToError(this.$refs.form);
      if (isValid) {
        this.$emit("goNext");
      }
    });
  }
}
